"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSvgImageString = exports.getSvgStringFromSymbolKey = exports.getSvgStringFromType = exports.imageCache = void 0;
const CircleBuilder_1 = __importDefault(require("./CircleBuilder"));
const LineBuilder_1 = __importDefault(require("./LineBuilder"));
const TriangleBuilder_1 = __importDefault(require("./TriangleBuilder"));
const MAX_CACHE = 128;
exports.imageCache = {}; // caches a value to an image
const getSvgStringFromType = (symbolType, attributes, options) => {
    switch (symbolType) {
        case 'triangle':
            return (0, TriangleBuilder_1.default)(Object.assign(Object.assign({}, attributes), options));
        case 'node': //legacy support
        case 'circle':
            return (0, CircleBuilder_1.default)(Object.assign(Object.assign({}, attributes), options));
        default:
            //Use circle as a default if nothing else matches
            return (0, CircleBuilder_1.default)(Object.assign(Object.assign({}, attributes), options));
    }
};
exports.getSvgStringFromType = getSvgStringFromType;
const getSvgStringFromSymbolKey = (id, options) => {
    // use a styled component if we have a symbolKey, otherwise use a generic
    const lineOrSymbol = id.split('_')[0];
    switch (lineOrSymbol) {
        case 'symbol':
            // symbol syntax symbol_nodeonly_ED7D31_
            const [, symbol, color, alphaNumericCharacter, alphaNumericScale, sizeScale, secondaryColor] = id.split('_');
            return (0, exports.getSvgStringFromType)(symbol, {
                primaryColor: color,
                secondaryColor: secondaryColor,
                sizeScale: Number(sizeScale) || 1,
                alphaNumericCharacter: alphaNumericCharacter,
                alphaNumericScale: Number(alphaNumericScale) || 1,
            }, options);
        case 'line':
            // line syntax line_solid_2_0000FF
            const [, lineType, lineWidth, lineColor] = id.split('_');
            return (0, LineBuilder_1.default)(Object.assign({ lineType, lineWidth: parseFloat(lineWidth), lineColor }, options)); // lineBuilder
        // if symbol vs line is not defined or the id is undefined, return '?' symbol
        default:
            return (0, exports.getSvgStringFromType)('', { primaryColor: '000000', alphaNumericCharacter: '\uf128' }, options);
    }
};
exports.getSvgStringFromSymbolKey = getSvgStringFromSymbolKey;
const getSvgImageString = (symbolKey, options) => {
    if (exports.imageCache[symbolKey]) {
        return exports.imageCache[symbolKey];
    }
    const renderString = (0, exports.getSvgStringFromSymbolKey)(symbolKey, options);
    function b64EncodeUnicode(str) {
        // first we use encodeURIComponent to get percent-encoded UTF-8,
        // then we convert the percent encodings into raw bytes which
        // can be fed into btoa.
        return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function toSolidBytes(match, p1) {
            //eslint-disable-next-line
            // @ts-ignore
            return String.fromCharCode('0x' + p1);
        }));
    }
    const testImg = 'data:image/svg+xml;Base64,' + b64EncodeUnicode(renderString);
    if (Object.keys(exports.imageCache).length < MAX_CACHE) {
        exports.imageCache[symbolKey] = testImg;
    }
    return testImg;
};
exports.getSvgImageString = getSvgImageString;
//# sourceMappingURL=SvgSymbol.js.map